import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/material';
import { FieldTypeConfig } from '@ngx-formly/core';
import { MatFormField, MatLabel, MatInput, MatSuffix, MatError } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { GwallHintComponent } from '../gwall-hint/gwall-hint.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-cyfrinair',
    templateUrl: './cyfrinair.component.html',
    styleUrls: ['./cyfrinair.component.scss'],
    imports: [MatFormField, MatLabel, MatInput, FormsModule, ReactiveFormsModule, MatIconButton, MatSuffix, MatIcon, MatError, GwallHintComponent, TranslatePipe]
})
export class CyfrinairComponent extends FieldType<FieldTypeConfig> {
  hide = true;
}
